/**
 * Manual Payment Configuration
 * Merchant phone numbers for Alif and DC Card payments
 * These are static for now and can be improved later (e.g., from backend config)
 */

export const MANUAL_PAYMENT_CONFIG = {
  alif: {
    phoneNumber: "+992 203 83 00 00",
    displayName: "Alif",
    description: "Pay securely with Alif mobile app",
  },
  dcCard: {
    phoneNumber: "+992 203 83 00 00",
    displayName: "DC Card",
    description: "Pay securely with DC Card mobile app",
  },
} as const;

export type ManualPaymentMethod = keyof typeof MANUAL_PAYMENT_CONFIG;
